import { render, staticRenderFns } from "./CommentDisplay.vue?vue&type=template&id=32beb7d0&"
import script from "./CommentDisplay.vue?vue&type=script&lang=js&"
export * from "./CommentDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports